import { SVGProps } from "react";

export function EmptyWallet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.2"
        d="M24.4797 18.5592C23.9259 19.0999 23.6094 19.8779 23.6885 20.7086C23.8072 22.1328 25.1127 23.1745 26.5368 23.1745H29.0422V24.7437C29.0422 27.4732 26.8137 29.7018 24.0841 29.7018H8.94613C6.21654 29.7018 3.98804 27.4732 3.98804 24.7437V15.8692C3.98804 13.1396 6.21654 10.9111 8.94613 10.9111H24.0841C26.8137 10.9111 29.0422 13.1396 29.0422 15.8692V17.7681H26.3786C25.6401 17.7681 24.9676 18.0582 24.4797 18.5592Z"
        fill="currentColor"
      />
      <path
        opacity="0.8"
        d="M20.2733 5.90004V10.9109H8.94613C6.21654 10.9109 3.98804 13.1394 3.98804 15.869V11.0296C3.98804 9.46039 4.95065 8.06257 6.41434 7.50874L16.8843 3.55282C18.5195 2.94624 20.2733 4.14624 20.2733 5.90004Z"
        fill="currentColor"
      />
      <path
        opacity="0.8"
        d="M30.44 19.1125V21.829C30.44 22.5543 29.8598 23.1476 29.1213 23.174H26.5368C25.1127 23.174 23.8072 22.1323 23.6885 20.7081C23.6094 19.8774 23.9259 19.0994 24.4797 18.5587C24.9676 18.0576 25.6401 17.7676 26.3786 17.7676H29.1213C29.8598 17.794 30.44 18.3873 30.44 19.1125Z"
        fill="currentColor"
      />
      <path
        d="M19.1525 17.5038H9.92196C9.38132 17.5038 8.93298 17.0555 8.93298 16.5149C8.93298 15.9742 9.38132 15.5259 9.92196 15.5259H19.1525C19.6931 15.5259 20.1414 15.9742 20.1414 16.5149C20.1414 17.0555 19.6931 17.5038 19.1525 17.5038Z"
        fill="currentColor"
      />
    </svg>
  );
}
